var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkelet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 209,
    viewBox: "0 0 234 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192.806 107.008L117.244 208.07L41.6813 107.008M192.806 107.008L157.706 0.53125M192.806 107.008L232.781 0.53125M41.6813 107.008L75.3188 0.53125M41.6813 107.008L1.21875 0.53125",
    stroke: "#0075FF",
    strokeOpacity: 0.1,
    strokeDasharray: "2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192.806 107.008L117.244 208.07L41.6813 107.008M192.806 107.008L157.706 0.53125M192.806 107.008L232.781 0.53125M41.6813 107.008L75.3188 0.53125M41.6813 107.008L1.21875 0.53125",
    stroke: "#6B95FF",
    strokeOpacity: 0.2,
    strokeDasharray: "2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkelet);
export default __webpack_public_path__ + "static/media/skelet.0ac7c4c6bf726f6c6fb98862504cb419.svg";
export { ForwardRef as ReactComponent };